<template>
  <div class="app-surface flex min-h-screen flex-col">
    <NavBar />

    <main class="flex flex-1 items-center justify-center px-4 py-10">
      <div class="w-full max-w-md rounded-2xl border border-jackfruit-100 bg-white p-6 shadow-soft sm:p-8">
        <div class="mb-8 text-center">
          <div class="mx-auto mb-4 grid h-12 w-12 place-items-center rounded-xl bg-jackfruit-pop text-2xl shadow-fruit">🍍</div>
          <h2 class="text-3xl font-black text-ink-900">加入菠萝蜜</h2>
          <p class="mt-2 text-sm text-ink-500">
            已有账号？
            <router-link to="/login" class="font-black text-pulp-600 hover:text-pulp-700">立即登录</router-link>
          </p>
        </div>

        <form class="space-y-5" @submit.prevent="handleRegister">
          <div>
            <label class="label">手机号</label>
            <input v-model="form.phone" type="tel" required class="input" placeholder="请输入手机号" />
          </div>

          <div>
            <div class="mb-1 flex items-center justify-between">
              <label class="label mb-0">验证码</label>
              <button
                type="button"
                @click="sendVerificationCode"
                :disabled="isSendingCode || countdown > 0"
                class="text-sm font-black text-pulp-600 hover:text-pulp-700 disabled:cursor-not-allowed disabled:text-ink-300"
              >
                <span v-if="isSendingCode">发送中...</span>
                <span v-else-if="countdown > 0">{{ countdown }}秒后重试</span>
                <span v-else>获取验证码</span>
              </button>
            </div>
            <input v-model="form.code" type="text" required maxlength="6" class="input" placeholder="请输入6位验证码" />
          </div>

          <div>
            <label class="label">密码</label>
            <input v-model="form.password" type="password" required class="input" placeholder="请输入密码（至少6位）" />
          </div>

          <div>
            <label class="label">确认密码</label>
            <input v-model="form.confirmPassword" type="password" required class="input" placeholder="请再次输入密码" />
          </div>

          <label class="flex items-start gap-2 text-sm leading-6 text-ink-600">
            <input v-model="form.acceptTerms" type="checkbox" required class="mt-1 h-4 w-4 rounded border-ink-100 text-jackfruit-500 focus:ring-jackfruit-400" />
            我已阅读并同意用户服务协议和隐私政策
          </label>

          <button type="submit" class="w-full rounded-xl bg-jackfruit-500 px-4 py-3 text-sm font-black text-ink-900 shadow-fruit transition hover:bg-jackfruit-600">
            创建账号，开始阅读
          </button>
        </form>
      </div>
    </main>
  </div>
</template>

<script setup lang="ts">
import { reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import NavBar from '@/components/NavBar.vue'

const router = useRouter()
const authStore = useAuthStore()

const form = reactive({
  phone: '',
  code: '',
  password: '',
  confirmPassword: '',
  acceptTerms: false
})

const isSendingCode = ref(false)
const countdown = ref(0)
let countdownTimer: number | null = null

const sendVerificationCode = async () => {
  if (!form.phone) {
    alert('请输入手机号')
    return
  }

  if (!/^1[3-9]\d{9}$/.test(form.phone)) {
    alert('请输入有效的手机号')
    return
  }

  if (isSendingCode.value || countdown.value > 0) return

  isSendingCode.value = true

  try {
    const result = await authStore.sendVerificationCode(form.phone)
    if (result.success) {
      countdown.value = 60
      countdownTimer = window.setInterval(() => {
        countdown.value--
        if (countdown.value <= 0 && countdownTimer) {
          clearInterval(countdownTimer)
          countdownTimer = null
        }
      }, 1000)
      alert('验证码已发送，请注意查收')
    } else {
      alert(result.error || '发送验证码失败')
    }
  } catch (error) {
    console.error('发送验证码失败:', error)
    alert('发送验证码失败，请稍后重试')
  } finally {
    isSendingCode.value = false
  }
}

const handleRegister = async () => {
  if (form.password !== form.confirmPassword) {
    alert('两次输入的密码不一致')
    return
  }

  if (!form.acceptTerms) {
    alert('请同意用户服务协议和隐私政策')
    return
  }

  const result = await authStore.register(form.phone, form.password, form.code)
  if (result.success) {
    router.push('/')
  } else {
    alert(result.error || '注册失败')
  }
}
</script>
